"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionValidator = void 0;
const __1 = require("..");
const get_account_identifier_1 = require("../utils/get-account-identifier");
class PermissionValidator {
    /**
     * Check if permissions were given for a certain message type.
     *
     * PermissionRequest and BroadcastRequest will always return true.
     *
     * @param message Beacon Message
     */
    static async hasPermission(message, getOne, getAll) {
        switch (message.type) {
            case __1.BeaconMessageType.PermissionRequest:
            case __1.BeaconMessageType.BroadcastRequest: {
                return true;
            }
            case __1.BeaconMessageType.OperationRequest: {
                const accountIdentifier = await get_account_identifier_1.getAccountIdentifier(message.sourceAddress, message.network);
                const permission = await getOne(accountIdentifier);
                if (!permission) {
                    return false;
                }
                return permission.scopes.includes(__1.PermissionScope.OPERATION_REQUEST);
            }
            case __1.BeaconMessageType.SignPayloadRequest: {
                const permissions = await getAll();
                const filteredPermissions = permissions.filter((permission) => permission.address === message.sourceAddress);
                if (filteredPermissions.length === 0) {
                    return false;
                }
                return filteredPermissions.some((permission) => permission.scopes.includes(__1.PermissionScope.SIGN));
            }
            default:
                throw new Error('Message not handled');
        }
    }
}
exports.PermissionValidator = PermissionValidator;
//# sourceMappingURL=PermissionValidator.js.map